// extracted by mini-css-extract-plugin
export default {"slide2":"slide2_slide2__-n+Nv"};